import * as yup from 'yup';

export const yupRepresentativeSchema = yup.object().shape({
  firstName: yup.string(),
  initials: yup.string(),
});
